<ng-container>
  <div class="page_popup">
    <div class="page_popup_container">
      <app-popin-dialog-header [titre]="titre" (closed)="close_popup()" [menu]="menu">
      </app-popin-dialog-header>
      <div class="page_popup_content">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
    <div class="page_popup_background" (click)="close_popup()"></div>
  </div>
</ng-container>
